import { createRef } from 'react';

// Holds the app-wide toast ref for shared notifications.
export const appToastRef = createRef();

// Shows a toast message using the app-wide toast host.
export const showToast = (message) => {
    if (appToastRef.current) {
        appToastRef.current.show(message);
    }
};
